import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import axios from "axios";
import pdf from "../../Assets/ReekrajRoyResume.pdf";
import { AiOutlineDownload } from "react-icons/ai";

function Resume() {
  const uri = "https://porfolio-backend.vercel.app/ranks/getRanks";
  const [spojRank, upadteSpojRank] = useState(0);
  const [hackerrank, upadteHackerank] = useState(0);
  const [sem, upadateSem] = useState(0);
  const [cgpa, upadteCgpa] = useState(0);

  useEffect(() => {
    axios
      .get(uri)
      .then((res) => {
        upadteSpojRank(res.data.message[0].spojRank);
        upadteHackerank(res.data.message[1].hackerrank);
        upadteCgpa(res.data.message[2].cgpa);
        upadateSem(res.data.message[3].sem);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Experience</h3>
            <Resumecontent
              title="Software Engineer @ UNext Learning"
              date="Aug 2023 — Present"
              content={[
                "Integrated ms-teams to the existing platform.",
                "Performed poc on different ms-graph apis, wrote logic for fetching post-session meeting artefacts, updated existing model to store meeting recordings and chat history.",
              ]}
            />
            <Resumecontent
              title="Software Engineering Intern @ UNext Learning"
              date="Jan 2023 — July 2023"
              content={[
                "Implemented front-end functionality for Survey module. Wrote apis, Swagger documentation, and performed automation testing using PlayWright.",
                "Fetching of chat history in Quiz module and using Xlsx service to facilitate downloading in an Excel Workbook.",
                "Exposing different properties received from MS-Graph apis to suit product requirements.",
                "Implemented features and logic for Quiz, Assignment, DF, Analytics Module.̀̀",
                "Skills: Express.js · AngularJS · TypeScript · Node.js · MongoDB",
              ]}
            />
            <Resumecontent
              title="Web Development Intern @ AasPass - Global to Local"
              date="June 2021 — Sep 2021"
              content={[
                "Worked in the pre-existing site.",
                "Built home page using HTML, CSS, JavaScript, tailwind css and tailblocks.",
              ]}
            />
            <Resumecontent
              title="Software Engineering Intern @ Lucid Education Group"
              date="Jan 2021 — April 2021"
              content={[
                "Deployed websites using HTML, CSS, JavaScript and PHP.",
                "Designed an user authentication dashboard using xampp, MariaDB and PHP.",
              ]}
            />
            <h3 className="resume-title">Extracurricular Activities</h3>
            <Resumecontent
              title="Student Representative @ Training and Placement cell of SMIT"
              content={[
                "Coordinate different circulars and notifications from the cell to the students.",
                "Work with the cell to ensure smooth functionality of  hiring events.",
              ]}
            />
            <Resumecontent
              title="Technical Manager @ INNOVISION, technical society of SMIT"
              content={[
                "Head of the technical  department for the session 2021-22.",
                "Posted curated content related to opportunities related to different domains.",
              ]}
            />
            <Resumecontent
              title="Editorial Department @ TEDxSMIT 2019 Edition"
              content={[
                "Contributed several articles for the social media team.",
                "Made detailed report on the speakers story.",
              ]}
            />
          </Col>
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <Resumecontent
              title="Sikkim Manipal Institute of Technology "
              date="July, 2019 - July, 2023"
              content={[`CGPA: ${9.70} (Till ${8}th Sem)`]}
            />
            <Resumecontent
              title="Delhi Public School Megacity, Kolkata"
              date="April, 2009 - March, 2019"
              content={["ISC Aggregate Precentage: 92.50%",
              "ICSE Aggregate Precentage: 96.40%"]}
            />
            <h3 className="resume-title">Ranks and Achivements</h3>
            <Resumecontent
              title=""
              content={[
                `Selected for AWS MLE Foundations course offered by Udemy in collaboration with AWS.`,
                `Embark Fellow - In top 2 percentile from amongst 400K students in Embark Upraised Assessment.`,
                ` Solved more than 500 coding questions across different platforms.`,
                `Completed HacktoberFest 2020 with submission of 6 pull requests.`,
                `More than 1K contributions on GitHub.`,
                `State Bank Honorary Award for meritorious students.`,
                `Highest scorer in Computer Science (ICSE).`,
              ]}
            />
            <h3 className="resume-title">Certifications</h3>
            <Resumecontent
              title=""

              content={[
                `AWS Fundamentals`,
                `NPTEL Python for Data Science`,
                `Microsoft Azure AZ-900 Exam and Cloud Services Certification`,
                `Google IT Support`,
              ]}
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
          <AiOutlineDownload />&nbsp;Download CV
          </Button>
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;
